import CryptoJS from 'crypto-js'
export default {
  encryption (pas) {
    var b = CryptoJS.enc.Base64
    var key = CryptoJS.enc.Utf8.parse('1493192322196807') //秘钥
    var iv= CryptoJS.enc.Utf8.parse('7287898088097802')
    var srcs = CryptoJS.enc.Utf8.parse(pas)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
      iv
    })
    return b.stringify(encrypted.ciphertext)
  }
}
